var $class="se2--navigation-bar-customer-journey-jump-to",$name="NavigationBarCustomerJourneyJumpTo",$path="app/components/NavigationBarCustomerJourneyJumpTo/config.js",$this={$class,$name,$path,};export const anchorTagItemClassName = 'anchor-tag-link';
export const tabClassName = 'tab';
export const tabsClassName = 'tabs';
export const navigationBarCustomerJourneyClassName = $class;
